export const QA_NAME_LISTING_PROFILE_DESCRIPTION_WIDGET = 'listingDescription'

export const QA_NAME_LISTING_PROFILE_DESCRIPTION_DISCARD =
  'listingDescriptionDiscard'

export const QA_NAME_LISTING_PROFILE_DESCRIPTION_VALUE =
  'listingDescriptionValue'

export const LISTING_PROFILE_DESCRIPTION_DISCARD_CONFIRMATION_PROPS = {
  description: 'RentalPortal.ListingProfileDescriptionDiscardTextKey',
  qaName: QA_NAME_LISTING_PROFILE_DESCRIPTION_DISCARD,
  title: 'RentalPortal.ListingProfileBlockDiscardTitleKey',
}
